import { pickT } from "@repo/shared";
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { T } from "./cost-chart-config-form.i18n";

type CostChartConfigFormProps = {
  flowLanguage: string;
  displayMode: "rolling" | "calendar";
  onDisplayModeChange: (mode: "rolling" | "calendar") => void;
  chartType: "line" | "bar";
  onChartTypeChange: (type: "line" | "bar") => void;
};

export function CostChartConfigForm({
  flowLanguage,
  displayMode,
  onDisplayModeChange,
  chartType,
  onChartTypeChange,
}: CostChartConfigFormProps) {
  const t = pickT(T, flowLanguage);

  return (
    <div className="space-y-4 border rounded-lg p-4 bg-muted/30">
      <div className="space-y-2">
        <Label htmlFor="cost-chart-display-mode">
          {t.displayMode} <span className="text-destructive">*</span>
        </Label>
        <Select
          value={displayMode}
          onValueChange={(v) => onDisplayModeChange(v as "rolling" | "calendar")}
        >
          <SelectTrigger id="cost-chart-display-mode">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="rolling">{t.rolling12Months}</SelectItem>
            <SelectItem value="calendar">{t.calendarYear}</SelectItem>
          </SelectContent>
        </Select>
        <p className="text-xs text-muted-foreground">
          {displayMode === "rolling" ? t.rollingModeDesc : t.calendarModeDesc}
        </p>
      </div>

      <div className="space-y-2">
        <Label htmlFor="cost-chart-type">
          {t.chartType} <span className="text-destructive">*</span>
        </Label>
        <Select value={chartType} onValueChange={(v) => onChartTypeChange(v as "line" | "bar")}>
          <SelectTrigger id="cost-chart-type">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="line">{t.lineChart}</SelectItem>
            <SelectItem value="bar">{t.barChart}</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </div>
  );
}
